module.exports = __webpack_public_path__ + "static/media/tree_img.3bb649aa.svg";